const DeliveryIcon = ({
  width=32,
  height=32,
  uniqueId,
  color,
  radiosColor1,
  radiosColor2,
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle r="16" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill={`url(#${uniqueId})`} />
      <circle r="14" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill="white"/>
      <g clipPath="url(#clip0_1815_28264)">
      <path d="M20.867 17.6563C20.7386 17.5279 20.5311 17.5279 20.4028 17.6563L18.2827 19.7742L17.587 19.0785C17.4586 18.9502 17.2511 18.9502 17.1228 19.0785C16.9944 19.2068 16.9944 19.4143 17.1228 19.5427L18.0517 20.4716C18.18 20.5999 18.3875 20.5999 18.5158 20.4716L20.867 18.1204C20.9953 17.9921 20.9953 17.7846 20.867 17.6563Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M18.9998 14C18.7198 14 18.4465 14.0266 18.1732 14.0733L9.59984 10.4C9.15984 10.2066 8.67317 10.5333 8.67317 11.0066L8.6665 14.1333C8.6665 14.4466 8.8865 14.72 9.1865 14.7866L14.6665 16L9.1865 17.22C8.8865 17.2866 8.6665 17.5533 8.6665 17.8666L8.67317 20.9866C8.67317 21.4666 9.15984 21.7866 9.59984 21.6L14.0532 19.6933C14.3932 22.1266 16.4732 24 18.9998 24C21.7598 24 23.9998 21.76 23.9998 19C23.9998 16.24 21.7598 14 18.9998 14ZM18.9998 22.6666C16.9798 22.6666 15.3332 21.02 15.3332 19C15.3332 16.98 16.9798 15.3333 18.9998 15.3333C21.0198 15.3333 22.6665 16.98 22.6665 19C22.6665 21.02 21.0198 22.6666 18.9998 22.6666Z" fill={color} />
      </g>
      <defs>
        <linearGradient id={uniqueId} x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor={radiosColor1} />
          <stop offset="0.885417" stopColor={radiosColor2} />
        </linearGradient>
        <clipPath id="clip0_1815_28264">
        <rect width="16" height="16" fill="white" transform="translate(8 8)"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default DeliveryIcon;
